import * as Slider from "@radix-ui/react-slider";

const customFormat = n => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
export default function InputSlider({
                                        label,
                                        value,
                                        setValue,
                                        min,
                                        max,
                                        step = 1,
                                        className = ""
                                    }) {
    return (
        <div className={`min-w-40 w-full ${className}`}>
            <label className="block text-[12px] mb-3">{label}</label>
            <div className="relative">
                <Slider.Root
                    value={[value]}
                    min={min}
                    max={max}
                    step={step}
                    onValueChange={([v]) => setValue(v)}
                    className="relative flex items-center select-none touch-none h-6"
                >
                    <Slider.Track className="relative h-2 w-full bg-gray-300 rounded">
                        <Slider.Range className="absolute h-full bg-gray-600 rounded" />
                    </Slider.Track>
                    <Slider.Thumb className="block w-4 h-4 bg-white border-2 border-gray-600 rounded-full focus:outline-none cursor-pointer">
                        <div className="absolute -top-4 left-1/2 -translate-x-1/2 text-[10px] text-white px-1.5 rounded whitespace-nowrap pointer-events-none"
                             style={{
                                 background: "linear-gradient(to bottom, #466888 0%, #304151 100%)"
                             }}
                        >
                            {customFormat(value)}
                        </div>
                    </Slider.Thumb>
                </Slider.Root>
                <div className="absolute flex justify-between text-[10px] text-white w-full -top-3">
                    <span className={`bg-[#686b6d] rounded px-1.5 transition-opacity ${
                        value > max * 0.16 ? "opacity-100" : "opacity-0"
                    }`}>{min}</span>
                    {<span className={`bg-[#686b6d] rounded px-1.5 transition-opacity ${
                        value < max * 0.75 ? "opacity-100" : "opacity-0"
                    }`}>{customFormat(max)}</span>}
                </div>
            </div>
            <div className="h-[14px]"></div>
        </div>
    );
}
